// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.2 (commit 4b41cf3d71aa85cd4e75c96cbb54324481ee0b27).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
import { ProjectileInfo as __ProjectileInfo } from "./projectile_info_type";

export type Enemy = {
  id: number,
  typeId: number,
  objectId: number,
  maxHealth: number,
  health: number,
  speed: number,
  isDead: boolean,
  isFiring: boolean,
  attackAngle: number,
  experience: number,
  projectileInfo: __ProjectileInfo,
  x: number,
  y: number,
};

/**
 * A namespace for generated helper functions.
 */
export namespace Enemy {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("id", AlgebraicType.createI32Type()),
      new ProductTypeElement("typeId", AlgebraicType.createI32Type()),
      new ProductTypeElement("objectId", AlgebraicType.createI32Type()),
      new ProductTypeElement("maxHealth", AlgebraicType.createI32Type()),
      new ProductTypeElement("health", AlgebraicType.createI32Type()),
      new ProductTypeElement("speed", AlgebraicType.createI32Type()),
      new ProductTypeElement("isDead", AlgebraicType.createBoolType()),
      new ProductTypeElement("isFiring", AlgebraicType.createBoolType()),
      new ProductTypeElement("attackAngle", AlgebraicType.createI32Type()),
      new ProductTypeElement("experience", AlgebraicType.createI32Type()),
      new ProductTypeElement("projectileInfo", __ProjectileInfo.getTypeScriptAlgebraicType()),
      new ProductTypeElement("x", AlgebraicType.createF32Type()),
      new ProductTypeElement("y", AlgebraicType.createF32Type()),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: Enemy): void {
    Enemy.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): Enemy {
    return Enemy.getTypeScriptAlgebraicType().deserialize(reader);
  }

}


